export function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20mobile%20app%20QR%20code%20mockup%20on%20warm%20coral%20background%2C%20modern%20app%20download%20screen%20design%2C%20soft%20lighting%2C%20professional%20product%20presentation%2C%20simple%20composition&width=560&height=560&seq=app-qr-zhainan&orientation=squarish"
                alt="宅男视频移动客户端下载"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              移动客户端
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              下载宅男视频移动客户端，随时随地畅享91视频、97视频及51视频网站海量高清资源。专为移动端优化的播放体验，流量节省模式让您无忧观看，推送提醒不错过任何精彩更新。支持iOS与Android双平台，安装即用。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
              <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </span>
              <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            如有视频投稿、商务合作或内容反馈需求，欢迎通过以下方式与我们取得联系。宅男视频团队期待与更多优质内容创作者和品牌伙伴携手合作，共同打造更丰富的数字视频平台生态。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
            <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
              <i className="ri-mail-line text-lg"></i>
              投稿/合作咨询
            </span>
            <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-service-line text-lg"></i>
              在线反馈
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于宅男视频
          </h2>
          <div className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              宅男视频成立于数字视频蓬勃发展的时代，是一个专注于汇聚主流数字品牌在线入口的综合视频平台。我们整合了91视频、97视频及51视频网站等优质资源，为用户提供一站式的免费高清在线观看服务。
            </p>
            <p>
              平台以"流畅不卡顿"为核心体验目标，采用先进的CDN加速与自适应码率技术，确保在不同网络环境下都能获得最佳的播放效果。从热门影视到独家内容，从短视频到长篇连载，宅男视频始终致力于丰富用户的数字娱乐生活。
            </p>
            <p>
              我们坚持每日更新内容库，严格把控资源质量，建立完善的分类与推荐体系，让每一位访问者都能快速找到心仪的视频内容。宅男视频，让精彩触手可及。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionFeatures() {
  const features = [
    {
      icon: 'ri-speed-up-line',
      title: '极速加载 · 不卡顿',
      desc: '采用智能CDN分发与P2P加速技术，91视频、97视频等全站资源秒开播放，无论高峰时段还是弱网环境，始终保持流畅无缓冲的观看体验。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全绿色 · 无广告干扰',
      desc: '平台通过多重安全检测机制，杜绝恶意弹窗与捆绑软件。纯净的播放环境让您专注于51视频网站及数字视频平台的海量内容，安心畅享每一刻。',
    },
    {
      icon: 'ri-stack-line',
      title: '海量资源 · 每日更新',
      desc: '覆盖91在线视频、97视频等主流数字品牌，资源库持续扩充。智能推荐算法根据您的观看偏好精准推送，每日都有新鲜内容等您发现。',
    },
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            为什么千万用户选择宅男视频？三大核心优势为您揭晓
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}